// Firebase Configuration
// IMPORTANT: Replace with your actual Firebase credentials
// This file should NOT be committed to version control

// Firebase Configuration
// Uses environment variables for security, with fallbacks for development
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDUWZohj3r9Npqjp5_S6Ygnl2Z104Fevpk",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "flashcards-992ab.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "flashcards-992ab",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "flashcards-992ab.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "924578244791",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:924578244791:web:68062e93ba3fd68df9c532",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-6MYHZGHQ31"
};

// Export configuration and utilities
export { firebaseConfig };
export const isDevelopment = import.meta.env.DEV;
